<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-header classes="no-border">
        <h3>{{'lang.globals.marker' | translate}}</h3>
      </div>
      <div card-header-more>
        <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
                   classes="btn-secondary actionButtonMinWidth" (click)="requestDebounced()" [disabled]="loading"
                   [loading]="loading">
          <sb-icon icon="refresh"></sb-icon>
        </sb-button>
      </div>
      <div card-fit>
        <div [ngClass]="isInModalContext ? 'clientsWrapper' : ''">
          <table class="table">
            <thead>
            <tr>
              <th>
                {{'lang.globals.name' | translate}}
              </th>
              <th>
                {{'lang.globals.id' | translate}}
              </th>
              <th>
                {{'lang.globals.resolution' | translate}}
              </th>
              <th class="text-end">
                {{'lang.globals.actions' | translate}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of data;">
              <td>
                {{ item?.name}}
              </td>
              <td>
                  <span *ngIf="item?.resolution?.id">
                    {{item?.resolution?.id}}
                  </span>
              </td>
              <td>
                <ng-container *ngIf="item?.resolution && item?.resolution?.width && item?.resolution?.height">
                  <span>
                    {{item?.resolution?.width}}px x {{item?.resolution?.height}}px
                  </span>
                </ng-container>
              </td>
              <td class="text-end">
                <sb-button *ngIf="isInModalContext"
                           classes="btn-hover-primary" (submitClicked)="select(item)" container="body"
                           ngbTooltip="{{'lang.globals.select' | translate}}" placement="left">
                  <sb-icon icon="checked"></sb-icon>
                </sb-button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div card-footer>
      </div>
    </sb-card>
  </div>
</div>
